export default __webpack_public_path__ + "static/GBP-ab2ce8d1906ef14ae086ddf2855460e9.jpg";